module.exports = {
  slug: `quiz-2`,
  title: `This is the second quiz`,
  meta: {
    title: `fb title`,
    desc: `fb desc`,
    image: require(`../assets/bars_mob.jpg`),
    whatsapp: `this is the whatsapp share!`
  },
  header: {
    title: `TAKE THE QUIZ`,
    subtitle: "Here`s some more copy about my amazing quiz!"
  },
  questions: [
    {
      backgroundImage: require(`../assets/hammer1.jpg`),
      backgroundImageMob: require(`../assets/hammer1_mob.jpg`),
      question: `Have you answered this question?`,
      answers: [
        `Yes`,
        `No`
      ],
      userAnswer: null,
      answer: 0,
      answerText: `Pretty sure you did`
    },
    {
      backgroundImage: require(`../assets/shoes.jpg`),
      backgroundImageMob: require(`../assets/shoes_mob.jpg`),
      question: `cake?`,
      answers: [
        `yes`,
        `no`
      ],
      userAnswer: null,
      answer: 0,
      answerText: `Obviously you want cake.`
    },
  ],
  signAsk: {
    image: require('../assets/bleach.jpg'),
    imageMob: require('../assets/bleach_mob.jpg'),
    title: `Before you get your results...`,
    copy: `<p>For women around the world, a courtroom can often mean anything but justice.</p>
    <p>Women still face discrimination and harmful stereotypes – even from the systems meant to protect them.</p>
    <p>At Amnesty, we believe the legal system should protect women's rights, not perpetuate sexism.</p>`,
    question: `<p>Will you add your name to say you agree?</p>`,
    yes_btn: `Yes, absolutely`,
    no_btn: `No, sorry`
  },
  sign: {
    image: require('../assets/bleach.jpg'),
    imageMob: require('../assets/bleach_mob.jpg'),
    title: `GREAT. THANKS!`,
    subTitle: `This is a quote!`,
    subTitle_quote: true,
    petitionTitle: `ADD YOUR NAME:`,
    EN_URL: `https://actions.amnesty.org.uk/page/61532/petition/1`
  },
  shareAsk: { // / results screen
    image: require('../assets/bleach.jpg'),
    imageMob: require('../assets/bleach_mob.jpg'),
    question: `<p>Pretty shocking, eh? Now – will you share this quiz with your friends? You’ll be helping to spread awareness of the injustice women face around the world, and it takes just 30 seconds.</p>`,
    yes_btn: `Yes, I'll share `,
    no_btn: `No, sorry`
  },
  donateAsk: {
    image: require('../assets/bleach.jpg'),
    imageMob: require('../assets/bleach_mob.jpg'),
    title: `Before you go...`,
    copy: `<p>At Amnesty, we challenge discrimination wherever we find it – holding authorities to account and fighting for a fairer world for women.</p>
    <p>Can you chip in to fund the fight back today?</p>`,
    yes_btn: `Yes, I'll chip in`,
    donate_link: `https://www.amnesty.org.uk/cart/checkout?purls-pers=1&amount=5&utm_campaign=WomensRightsQuiz&utm_source=WomensRightsQuiz&utm_medium=referral&utm_content=DonateButtonOn`,
    no_btn: `No, sorry`
  },
  thanks: {
    image: require('../assets/bleach.jpg'),
    imageMob: require('../assets/bleach_mob.jpg'),
    title: `THANKS FOR TAKING THE QUIZ`,
    copy: `<p>It highlights just a few startling stories about the injustice women face around the world.</p>
    <p>If, like us, you want to take action to help women achieve justice, take a look at some of our most urgent campaigns today.</p>`,
    btn_text: `SHOW ME URGENT CAMPAIGNS`,
    btn_link: `https://www.amnesty.org.uk/issues/womens-human-rights`
  }
}